'use client';

import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { useLiveNightsTick } from 'components/landing/v3/worldSleep/useLiveNightsTick';
import { CustomImage } from 'components/shared/custom-image';
import { useTextReveal } from './hooks/useTextReveal';
import styles from './NightsTracked.module.css';

/* Live count as on the homepage's WorldSleepSection: seeded server-side, ticked client-side. */
export const NightsTracked = ({
  nights,
  nightsPer5m,
}: {
  nights: number;
  nightsPer5m: number;
}) => {
  const tHome = useTranslations('homepage');
  const sectionRef = useRef<HTMLElement>(null);
  const countRef = useRef<HTMLParagraphElement>(null);

  useLiveNightsTick(countRef, sectionRef, nights, nightsPer5m);
  useTextReveal(sectionRef);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.card}>
        <div className={styles.photo}>
          <CustomImage
            src="web_v2/why-ultrahuman/nights-tracked-v2.jpg"
            alt=""
            fill
            sizes="(min-width: 992px) 100vw, 160vw"
          />
        </div>
        <div className={styles.copy}>
          <p className={styles.label} data-reveal>
            {tHome('homepage.worldSleep.facts.nightsTracked')}
          </p>
          <p ref={countRef} className={styles.count} data-reveal>
            {nights.toLocaleString('en-US')}
          </p>
        </div>
      </div>
    </section>
  );
};
